import { DriverInfo, IFormFilterDriver, ListDriverInfo, VehicleInfo } from "types/list-card-holder"

export const filterDrivers = (filterValues: IFormFilterDriver) => {
    const { lastName, firstName, email, status } = filterValues
    return (driver: DriverInfo) => {
        const firstNameMatch = (driver.firstName ?? "")
            .toLowerCase()
            .includes(firstName.toLowerCase())
        const lastNameMatch = (driver.lastName ?? "")
            .toLowerCase()
            .includes(lastName.toLowerCase())
        const emailMatch = (driver.email ?? "")
            .toLowerCase()
            .includes(email.toLowerCase())
        const statusMatch =
            (status === "Actif" && driver.active) ||
            (status === "Inactif" && !driver.active) ||
            status === "Tous"
        return firstNameMatch && lastNameMatch && emailMatch && statusMatch
    }
}

export const filterVehicles = (filterValues: IFormFilterDriver) => {
    const {
        licensePlate = "",
        description = "",
        status = "Tous",
    } = filterValues
    return (vehicle: VehicleInfo) => {
        const licensePlateMatch = vehicle.licensePlate
            ?.toLowerCase()
            .includes(licensePlate.toLowerCase())

        const descriptionMatch =
            description === ""
                ? true
                : (vehicle.description
                      ?.toLowerCase()
                      .includes(description.toLowerCase()) ?? false)

        const statusMatch =
            status === "Tous" ||
            (status === "Actif" && vehicle.active) ||
            (status === "Inactif" && !vehicle.active)

        return licensePlateMatch && descriptionMatch && statusMatch
    }
}

export const findDuplicateDriver = (
    firstName: string,
    lastName: string,
    DriverExistName: ListDriverInfo
) => {
    const duplicateDriver = DriverExistName.some((driver) => {
        if (
            (driver.firstName ?? "").toLowerCase() ===
                firstName.toLowerCase() &&
            (driver.lastName ?? "").toLowerCase() === lastName.toLowerCase()
        )
            return true
    })
    return duplicateDriver
}
